import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getModulosCliente (payload, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getCompany)
    })
  } else {
    const req = {
      url: 'api/cifempresas/getmoduloscifempresa',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: payload,
      params,
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getModulosCliente }
